import { getHashedObject } from './getHashedObject'

export const getObjectsComparison = (obj1?: object, obj2?: object) => {
  return getHashedObject(obj1) === getHashedObject(obj2)
}
